import { InertiaApp } from '@inertiajs/inertia-vue'
import pl from 'vuetify/es5/locale/pl';
import Vuetify from 'vuetify'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'

Vue.use(VueAxios, axios)
Vue.use(Vuetify);
Vue.use(InertiaApp);
Vue.use(VueI18n);

import Layout from "./Pages/Layout/Layout";
import i18n from "./i18n";

new Vue({
    vuetify: new Vuetify({
        lang: {
            locales: {pl},
            current: 'pl',
        },
    }),
    i18n,
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: (name) => {
                const module = require(`./Pages/${name}`);
                if (!module.default.layout) {
                    module.default.layout = Layout
                }
                return module.default
            }
        },
    }),
}).$mount('#app')
